export enum EPayrollType {
    Expenses,
    Time
}
